










































































import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { getErrorMsg } from "@/types";
import DesignerDetails from "../Project/DesignerDetails.vue";
import { get } from "@/api";
import { DynamicApiSelect } from "@canvas/componentlibrary";
import DesignerNotifyCard from "../Lead/DesignerNotifyCard.vue";

export default Vue.extend({
  components: {
    DesignerDetails,
    DynamicApiSelect,
    DesignerNotifyCard,
  },
  data(): { [key: string]: any } {
    return {
      isDesignerAssigned: false,
      isBroadcastPolling: false,
      designerPollWaitTime: 60,
      broadcastInterval: 0,
      designersNotified: true,
      saveBtn: {
        isDisabled: false,
        text: "Assign",
      },
      selectedReason: {
        reassignment_reason: null,
        reassignment_comment: "",
      },
      // isReAssignDesigner: false,
      selectedUser: {} || null,
      orderType: "Active",
    };
  },

  computed: {
    ...mapState("appModule", {
      designerDetails: "assignedDesigner",
      projectLead: "projectLead",
      partialProject: "partialProject",
      currentProject: "currentProject",
      reasonOptions: "enums",
      countryCode: "countryCode",
      leadType: "leadType",
    }),
    ...mapState("uiModule", {
      unique_segment_key: "unique_segment_key",
    }),
    designerDataSource(): string {
      let country = "";
      switch ((this as any).countryCode) {
        case "SG":
          country = "SGP";
          break;
        case "IN":
          country = "IND";
          break;
        case "SA":
          country = "KSA";
          break;
        default:
          country = (this as any).countryCode;
          break;
      }
      return `/sparrow/api/v1/users?filter=activation.status:ACTIVE;country:${country}&search=`;
    },
  },
  watch: {
    designerDetails(newVal, oldVal) {
      if (newVal) {
        if (
          !(this as any).isBroadcastPolling &&
          !(this as any).isDesignerAssigned &&
          !(this as any).designerDetails
        ) {
          //for the condition when socket is open and designer was assigned meanwhile
          (this as any).$store.dispatch("uiModule/addToast", {
            severity: "error",
            duration: 0,
            message: "Designer has already been assigned to this project.",
          });
        }
        (this as any).isDesignerAssigned = true;
        (this as any).isBroadcastPolling = false;
        (this as any).closeSocketConnection();
        clearInterval((this as any).broadcastInterval);
        (this as any).closeSocketConnection();
      }
    },
  },
  methods: {
    ...mapActions("appModule", [
      "assignDesignerUser",
      "broadcastEcLead",
      "closeSocketConnection",
      "pollForDesigners",
      "getProjectLead",
      "getProjectDetails",
    ]),
    ...mapActions("appModule", ["getFormStructureSchema"]),
    onDropdownOptionSelected(selected: { name: string; display_name: string }) {
      (this as any).selectedReason.reassignment_reason = selected;
    },
    handleInput(eventData: string) {
      (this as any).selectedReason.reassignment_comment = eventData;
    },
    handleUserSelect(selected: { name: string; display_name: string }) {
      (this as any).selectedUser = selected;
    },
    getResource(url: string) {
      let ctx = this;
      if (url.startsWith("/sparrow/api/v1/users")) {
        const query = url.split("?")[1];
        return get({
          endpoint: "sparrow.api.v1.users",
          query: query,
        }).then((response: any) => {
          const transformedUsers = response.records.map((item: any) => {
            return {
              id: item.login_id,
              name: `${item.first_name} ${item.last_name}`,
              first_name: item.first_name,
              last_name: item.last_name,
              email: item.email,
              phone: item.phone,
              image_url: item.image_url,
            };
          });
          ctx.$store.commit("appModule/storeSearchedUsers", transformedUsers);
          return response.records.map((item: any) => {
            return {
              name: item.login_id,
              display_name: `${item.first_name} ${item.last_name}`,
              extras: {
                email: item.email,
                image_url: item.image_url,
              },
            };
          });
        });
      } else {
        throw new Error("Unrecognized url");
      }
    },
    formatDate(date: string) {
      if (date) {
        const formatDate = new Date(date).toJSON();
        return formatDate.substring(0, formatDate.length - 1);
      }
      return "";
    },
    broadcastEcLeadCreation() {
      //get the respective data from the forms and dispatch the action
      return (this as any)
        .broadcastEcLead()
        .then((response: { notified_designers: number }) => {
          if (response.notified_designers > 0) {
            (this as any).designersNotified = true;
            (this as any).$store.dispatch("uiModule/addToast", {
              severity: "success",
              message:
                "Lead broadcasted to " +
                response.notified_designers +
                " Studio Directors",
            });
            return response;
          } else {
            (this as any).designersNotified = false;
            throw new Error("No Designer available for notification");
          }
        })
        .catch((err: any) => {
          throw err;
        });
    },
    goToPrevStep() {
      // (this as any).isReAssignDesigner = false;
      (this as any).isDesignerAssigned = true;
      (this as any).selectedUser = null;
      (this as any).selectedReason = Object.assign(
        (this as any).selectedReason,
        {
          reassignment_reason: null,
          reassignment_comment: "",
        }
      );
    },
    goToNextStep() {
      let resPromise: Promise<any> | undefined;
      resPromise = (this as any).handleWithDecorationAction(
        (this as any).assignDesigner,
        (this as any).saveBtn
      );
      if (resPromise) {
        resPromise
          .then((response: any) => {
            (this as any).isDesignerAssigned = true;
            (this as any).$store.dispatch("uiModule/addToast", {
              severity: "success",
              message:
                "Designer " +
                response.name +
                " (" +
                response.email +
                ") assigned to Project",
            });
            //segment event
            (this as any).$store.dispatch("appModule/trackSegementEvents", {
              eventName: "DESIGNER_MANUALLY_ASSIGNED",
              properties: {
                designer_details: response,
                project_id: (this as any).partialProject.project_id,
                lead_id: (this as any).$router.currentRoute.params.lead_id,
                unique_segment_key: (this as any).unique_segment_key,
              },
            });
            (this as any).$store.commit("appModule/assignDesigner", response);
          })
          .catch((err: any) => {});
      }
    },
    assignDesigner() {
      const formdata_designer = (this as any).selectedUser;
      if (formdata_designer && formdata_designer.name) {
        let assignRequest = {
          user_id: formdata_designer.name,
        };
        return (this as any).assignDesignerUser(assignRequest);
      } else {
        return Promise.reject({ message: "No Designer selected" });
      }
    },
    handleWithDecorationAction(
      asyncFunc: (...args: any) => Promise<any>,
      button: { disabled: boolean }
    ) {
      button.disabled = true;
      return asyncFunc
        .apply(arguments)
        .then((response: any) => {
          button.disabled = false;
          return response;
        })
        .catch((err: any) => {
          button.disabled = false;
          (this as any).$store.commit("uiModule/hideLoadingModal", null, {
            root: true,
          });
          (this as any).$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: getErrorMsg(err),
          });
          throw err;
        });
    },
    showBroadcastingLead() {
      (this as any).isBroadcastPolling = true;
      (this as any).broadcastInterval = setInterval(() => {
        (this as any).designerPollWaitTime -= 1;
        if ((this as any).designerPollWaitTime <= 0) {
          clearInterval((this as any).broadcastInterval);
          (this as any).isBroadcastPolling = false;
          (this as any).isDesignerAssigned = false;
        }
      }, 1000);
    },
  },
  mounted() {
    (this as any).isDesignerAssigned = false;
    (this as any).isBroadcastPolling = false;
    (this as any).designerPollWaitTime = 60;
    //if project lead and partial project is not present then route user to project create
    if (
      (this as any).$router.currentRoute.params.lead_id &&
      (this as any).$router.currentRoute.params.project_id &&
      (this as any).projectLead &&
      (this as any).partialProject &&
      (this as any).countryCode === "IN"
    ) {
      /* (this as any)
              .handleWithDecorationAction(
                //(this as any).broadcastEcLeadCreation,
                (this as any).saveBtn
              )
              .then((response: any) => {
                if (response) {
                 // (this as any).showBroadcastingLead();
                  (this as any).pollForDesigners();
                } else {
                  //(this as any).isBroadcastPolling = false;
                  (this as any).isDesignerAssigned = false;
                }
              })
              .catch((err: any) => {
                //(this as any).isBroadcastPolling = false;
                (this as any).isDesignerAssigned = false;
              }); */
    } else {
      //(this as any).isBroadcastPolling = false;
      (this as any).isDesignerAssigned = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "details") {
      next(false);
    } else {
      (this as any).closeSocketConnection();
      next();
    }
  },
});
